<template>
  <div>
    <v-text-field
      v-model="search"
      class="search-input"
      label="Поиск"
      color="accent"
      single-line
      hide-details
      @keypress.enter="searchRound"
    >
      <template #append-outer>
        <v-icon class="icon" style="font-size: 18px" @click="searchRound">fas fa-check</v-icon>
        <v-icon class="icon" @click="cancelSearch">fas fa-times</v-icon>
      </template>
    </v-text-field>
    <paginated-table
      :pullFunction="pullFunction"
      :items="!searchRounds.length ? items : searchRounds"
      :headers="headers[gameId]"
    >
      <template #items="props">
        <BetItem :item="props.item" :gameId="gameId" />
      </template>
    </paginated-table>
  </div>
</template>

<script>
import BetItem from './BetItem'
import PaginatedTable from '../../../PaginatedTable'
import { getStatisticsBets } from '../../../../../api/wheel'
import { getStatisticsRounds } from '../../../../../api/dice'
import { getStatisticsRoundsMines } from '../../../../../api/mines'
import { getStatisticsRoundsFrutto } from '../../../../../api/frutto'

export default {
  name: 'BetsTable',
  components: { PaginatedTable, BetItem },
  props: {
    items: Array,
    pullFunction: Function,
    gameId: Number
  },
  data () {
    return {
      search: '',
      searchRounds: [],
      headers: [
        [
          { text: 'id Раунда', value: 'round_id' },
          { text: 'Дата и время', value: 'created_at' },
          { text: 'Ставка-коэффициент', value: 'sector_value.value' },
          { text: 'Ставка', value: 'value' },
          { text: 'Коэф.', value: 'factor' },
          { text: 'Выигрыш', value: 'prize' }
        ],
        [
          { text: 'id Раунда', value: 'game_id' },
          { text: 'Дата и время', value: 'created_at' },
          { text: 'Напр.', value: 'orientation' },
          { text: 'Шанс', value: 'rate' },
          { text: 'Ставка', value: 'bet' },
          { text: 'Рузультат', value: 'result' },
          { text: 'Коэф.', value: 'factor' },
          { text: 'Выигрыш', value: 'prize' }
        ],
        [
          { text: 'id Раунда', value: 'game_id' },
          { text: 'Дата', value: 'created_at' },
          { text: 'Ставка', value: 'bet' },
          { text: 'Открытые ячейки', value: 'opened_cells' },
          { text: 'Количество бомб', value: 'mines_count' },
          { text: 'Коэф.', value: 'factor' },
          { text: 'Выигрыш', value: 'prize' }
        ],
        [
          { text: 'id Раунда', value: 'round_id' },
          { text: 'Дата', value: 'created_at' },
          { text: 'Ставка', value: 'value' },
          { text: 'Коэф.', value: 'factor' },
          { text: 'Автовывод', value: 'auto_take' },
          { text: 'Выигрыш', value: 'prize' },
          { text: 'Результат раунда', value: 'result' }
        ],
        [
          { text: 'id Раунда', value: 'game_id' },
          { text: 'Дата', value: 'created_at' },
          { text: 'Ставка', value: 'bet' },
          { text: 'Открытые ячейки', value: 'opened_cells' },
          { text: 'Сложность', value: 'difficult' },
          { text: 'Коэф.', value: 'factor' },
          { text: 'Выигрыш', value: 'prize' }
        ]
      ],
      pagination: {
        sortBy: 'time_start',
        descending: true
      },
      loading: true
    }
  },
  watch: {
    pagination () {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  mounted () {
  },
  methods: {
    searchRound () {
      const rows = 25
      if (this.gameId === 0)
        getStatisticsBets({
          user_id: this.$route.params.user,
          limit: rows,
          offset: 0,
          round_id: `${this.search}`
        }).then(response => {
          this.searchRounds = response.data.items
        })
      else if (this.gameId === 1)
        getStatisticsRounds({
          user_id: this.$route.params.user,
          limit: rows,
          offset: 0,
          game_id: `${this.search}`
        }).then(response => {
          this.searchRounds = response.data.items
        })
      else if (this.gameId === 2)
        getStatisticsRoundsMines({
          user_id: this.$route.params.user,
          limit: rows,
          offset: 0,
          game_id: `${this.search}`
        }).then(response => {
          this.searchRounds = response.data.items.map(i => {
            i.opened_cells = i.opened_cells.length
            return i
          })
        })
      else if (this.gameId === 4)
        getStatisticsRoundsFrutto({
          user_id: this.$route.params.user,
          limit: rows,
          offset: 0,
          game_id: `${this.search}`
        }).then(response => {
          this.searchRounds = response.data.items.map(i => {
            i.opened_cells = i.opened_cells.length
            return i
          })
        })

    },
    cancelSearch () {
      this.search = ''
      this.searchRounds = []
    }
  }
}
</script>

<style scoped>
    .icon {
        cursor: pointer;
        font-size: 20px;
        padding: 2px 4px;
    }

    .icon:hover {
        background: #eeeef4;
        border-radius: 4px;
    }

    .search-input {
        flex: none;
        width: 30%;
        margin-left: auto;
        margin-bottom: 10px;
    }
</style>
